/**
 * Conference activities (non-speaker events) shown in track schedules.
 * Use 24-hour time format (e.g. "08:00", "13:00") for sorting.
 * Track names must match SessionsSection tracks exactly.
 * Adding in or at to the room here instead of forcing 'in' in the ActivityCard component.
 * example: room: 'in (WBC 110-112)' or 'at Lumen Detroit'
 */
export const conferenceActivities = [
  {
    id: 'careers-review',
    track: 'Careers',
    title: 'Resume Review & Mock Interviews',
    content: 'Sign Up Here:',
    cta: {
      url: 'https://bit.ly/iwd-26-careers-signup',
      text: 'Get an appointment with a professional',
      ariaLabel:
        'Sign up for resume review and mock interviews -- Link opens in new tab',
    },
    time: '10:00',
    timeEnd: '12:00',
    room: 'in Value Conference Room',
  },
  {
    id: 'careers-resume-review',
    track: 'Careers',
    title: 'Resume Review & Mock Interviews',
    content: 'Sign Up Here:',
    cta: {
      url: 'https://bit.ly/iwd-26-careers-signup',
      text: 'Get an appointment with a professional',
      ariaLabel:
        'Sign up for resume review and mock interviews -- Link opens in new tab',
    },
    time: '14:00',
    timeEnd: '16:00',
    room: 'in Value Conference Room',
  },
  {
    id: 'careers-mentoring',
    track: 'Careers',
    title: 'Career Mentorship',
    content: 'Sign Up Here:',
    cta: {
      url: 'https://bit.ly/iwd-26-careers-signup',
      text: 'Get an appointment with a mentor',
      ariaLabel: 'Sign up for mentorship -- Link opens in new tab',
    },
    time: '10:00',
    timeEnd: '12:00',
    room: 'in Value Conference Room',
  },
  {
    id: 'careers-mentorship',
    track: 'Careers',
    title: 'Career Mentorship',
    content: 'Sign Up Here:',
    cta: {
      url: 'https://bit.ly/iwd-26-careers-signup',
      text: 'Get an appointment with a mentor',
      ariaLabel: 'Sign up for a mentor session -- Link opens in new tab',
    },
    time: '14:00',
    timeEnd: '16:00',
    room: 'in Value Conference Room',
  },
  {
    id: 'schedule-checkin',
    track: 'Schedule',
    title: 'Check-In & Breakfast',
    content: null,
    time: '08:00',
    timeEnd: '09:00',
    room: null,
  },
  {
    id: 'schedule-yoga',
    track: 'Schedule',
    title: 'Morning Mindfulness & Meditative Yoga',
    content: null,
    time: '08:15',
    timeEnd: '08:45',
    room: 'near stairs and Value Conference Room',
  },
  {
    id: 'schedule-welcome',
    track: 'Schedule',
    title: 'Welcome & Opening Remarks',
    content: null,
    time: '09:00',
    timeEnd: '09:10',
    room: null,
  },
  {
    id: 'schedule-panel',
    track: 'Schedule',
    title: 'Innovation Summit Panel Discussion',
    content: null,
    time: '09:10',
    timeEnd: '10:00',
    room: null,
  },
  {
    id: 'schedule-sessions-morning',
    track: 'Schedule',
    title: 'Sessions',
    content: null,
    time: '10:00',
    timeEnd: '12:00',
    room: null,
  },
  {
    id: 'schedule-lunch',
    track: 'Schedule',
    title: 'Lunch Break & Networking',
    content: null,
    time: '12:00',
    timeEnd: '13:00',
    room: 'near Value Conference Room',
  },
  {
    id: 'schedule-headshots',
    track: 'Schedule',
    title: 'Professional Headshots',
    content: null,
    time: '12:00',
    timeEnd: '13:00',
    room: 'near stairs and Value Conference Room',
  },
  {
    id: 'schedule-keynote',
    track: 'Schedule',
    title: 'Innovation Summit Keynote',
    content: null,
    time: '13:00',
    timeEnd: '14:00',
    room: 'Pizza Treat',
  },
  {
    id: 'schedule-sessions-afternoon',
    track: 'Schedule',
    title: 'Sessions',
    content: null,
    time: '14:00',
    timeEnd: '16:00',
    room: null,
  },
  {
    id: 'schedule-closing',
    track: 'Schedule',
    title: 'Closing Remarks & Scholarship Awardees',
    content: null,
    time: '16:00',
    timeEnd: '16:30',
    room: null,
  },
  {
    id: 'schedule-techie-hour',
    track: 'Schedule',
    title: 'Techie Hour & Networking',
    content: null,
    time: '16:30',
    timeEnd: '18:00',
    room: 'at Sessions',
  },
]
